import { DangerousConfigReceive, SortChange, AdsViewUpdate } from './types';

export const SORT_CHANGE = 'SORT_CHANGE';
export const ADS_VIEW_UPDATE = 'ADS_VIEW_UPDATE';
export const DANGEROUS_CONFIG_RECEIVE = '__DANGEROUS_CONFIG_RECEIVE';
export const INFO_PAGES_RECEIVE = 'INFO_PAGES_RECEIVE';
export const SESSION_RECEIVE = 'SESSION_RECEIVE';

export function dangerousConfigReceive(data: DangerousConfigReceive) {
  return {
    type: DANGEROUS_CONFIG_RECEIVE,
    market: data.market,
    markets: data.markets,
    server: data.server,
    routes: data.routes,
  };
}

export const sortChange = (data: SortChange) => ({
  type: SORT_CHANGE,
  data,
});

export const adsViewUpdate = (view: AdsViewUpdate) => ({
  type: ADS_VIEW_UPDATE,
  view,
});

export default {
  sortChange,
  adsViewUpdate,
};
